import { Link } from "react-router-dom";
import { useEffect } from "react";
import gsap from "gsap";
import React from "react";
import "./About.css";
var About = function () {
  useEffect(() => {
    const tl = gsap.timeline();
    tl.from("#About_bo", { duration: 1, opacity: 0, x: "-100%" });
    tl.from("#aboutME", { duration: 1, opacity: 0, y: "-50%" });
    tl.from(".aboutLIST", {
      duration: 1,
      opacity: 0,
      y: "80%",
      stagger: 0.2,
      rotate: "6deg",
    });
  }, []);
  return (
    <div>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>About</title>
      <link
        rel="stylesheet"
        type="text/css"
        id="applicationStylesheet"
        href="About.css"
      />
      <div id="About">
        <div id="menu">
          <div id="menu_text">
            <span className="menuItems">
              <Link to="/">Home</Link>
            </span>
            <span className="menuItems" style={{ fontSize: "2rem" }}>
              <Link to="/about">About</Link>
            </span>

            <span className="menuItems">
              <Link to="/work">Works</Link>
            </span>

            <span className="menuItems">
              <Link to="/contact">Contact</Link>
            </span>
          </div>
        </div>
        <div id="Group_4">
          <div id="About_bo">
            <span id="About__Span">About</span>
          </div>
          <div id="I_am_a_solid_designer_with_fla">
            <div>
              <div id="aboutME">
                I am a solid designer with flawless typographic skills mixed
                with gorgeous UI designs. My specialties are User Interface
                Design, User Experience Design, Seo, Wordpress, WireFrame CC.
                <br />I have done freelancing work for over an year now.
                <br />
                <br />
                The tools I use :-
                <br />
                <br />
              </div>
              <div className="aboutLIST">Adobe XD</div>

              <div className="aboutLIST">Figma</div>

              <div className="aboutLIST">Sketch</div>

              <div className="aboutLIST">Photoshop</div>

              <div className="aboutLIST">Illustrator</div>

              <div className="aboutLIST">Webflow</div>

              <div className="aboutLIST">Adobe Suite</div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
